{
  "title": "PoultryNEXT Layers",
  "title_Agrifirm": "PoultryNEXT Layers",
  "home": "Home",
  "save": "Opslaan",
  "save-and-next-week": "Opslaan en open de volgende week",
  "week": "Week",
  "app": {
    "flock": "Koppel legpluimvee",
    "settings": "Instellingen",
    "management": "Beheer",
    "products": "Producten",
    "advices": "Adviezen",
    "feed-advice": "Voeradvies",
    "reference-scheme": "Standaard Voeradviezen",
    "breeders": "Koppel vermeerdering"
  },
  "settings": {
    "navigation": {
      "barns": "Stallen",
      "sustainability": "Duurzaamheid"
    },
    "barn": "Stal",
    "no-barns": {
      "description": "Voeg een stal toe en deze zal hier worden getoond.",
      "title": "Er zijn nog geen stallen toegevoegd"
    },
    "barn-item": {
      "title-create": "Aanmaken Stal",
      "title-edit": "Wijzigen Stal",
      "add": "Toevoegen",
      "area": "Oppervlakte",
      "name": "Stal omschrijving",
      "error-name-duplicate": "Deze stalnaam is al in gebruik, voer een unieke stalnaam in",
      "error-name-required": "Voer de stalnaam in",
      "error-surface-area": "Voer het oppervlakte in",
      "delete-item": "Wilt u de stal verwijderen?",
      "silo": "Silo"
    }
  },
  "egg-marketing-standards": {
    "organic": "Biologisch",
    "free-range": "Vrije uitloop",
    "cage-free": "Scharrel",
    "caged": "Kolonie"
  },
  "flock-saved": "Het koppel is opgeslagen.",
  "confirm-delete-flock": "Weet u zeker dat u het koppel wilt verwijderen?",
  "flock-deleted": "Het koppel is verwijderd.",
  "flock-overview": {
    "flock": "Koppel",
    "placeholder": "Selecteer een koppel",
    "selector-option-flock": "Koppel",
    "selector-option-barn": "Stal",
    "print": "Rapport(en) printen",
    "new-flock": "Nieuw koppel",
    "add-week": "Week toevoegen",
    "download-all": "Koppel Rapport (.pdf)",
    "download-animal-count": "Diertelkaart (.pdf)",
    "download-summary": "Download samenvatting (.pdf)",
    "panel": {
      "arrival-title": "Opzet",
      "weekregistrations-title": "Weekregistraties",
      "departure-title": "Afvoer",
      "add-arrival": "Opzet toevoegen",
      "add-departure": "Afvoer toevoegen",
      "edit-arrival": "Opzet wijzigen",
      "edit-departure": "Afvoer wijzigen",
      "emptymessage-arrival": "U dient eerst een opzet aan te maken voor dit koppel.",
      "emptymessage-weekregistrations": "U heeft nog geen weekregistraties ingevoerd.",
      "emptymessage-departure": "Er is nog geen afvoer bekend.",
      "flock-id": "Koppel ID",
      "egg-marketing-standard": "Handelsnorm",
      "hatchery-name": "Broederij",
      "amount-of-hens": "Aantal hennen",
      "breed-name": "Ras",
      "barn-name": "Stal",
      "chick-birthdate": "Geboortedatum",
      "arrival-date": "Opzetdatum",
      "delete": "Koppel verwijderen",
      "departure-date": "Afvoerdatum",
      "departure-amount": "Aantal",
      "departure-weight": "Hengewicht (g)",
      "housing-system": "Huisvestingssysteem",
      "amount-of-roosters": "Aantal hanen",
      "delete-breeder-flock": "Koppel verwijderen",
      "feed-system-hens": "Voersysteem hennen",
      "feed-system-roosters": "Voersysteem hanen",
      "drink-system": "Drinksysteem",
      "hen-weight": "Hengewicht (g)",
      "rooster-weight": "Hanengewicht (g)",
      "nest": "Nest",
      "rearing-organization": "Opfokker",
      "transport-distance": "Transport vanaf opfokker (km)"
    },
    "week-registrations": {
      "sortByAscending": "Week oplopend",
      "sortByDescending": "Week aflopend",
      "edit": "Bewerken",
      "delete": "Verwijderen",
      "kpis": {
        "AverageEggWeight": "Gemiddeld eigewicht",
        "AverageEggWeightPerLayerPerDay": "Eimassa",
        "AverageLayerWeight": "Hengewicht",
        "EggCountPerLayerInProduction": "Ei poh",
        "EggCountPerLayerInProductionCumulative": "Ei poh cum",
        "FeedConsumption": "Voer",
        "FeedConsumptionPerLayerInProduction": "Voer poh",
        "FeedConsumptionPerLayerInProductionCumulative": "Voer poh cum (kg)",
        "FeedConsumptionPerLayerPerDay": "Voer phpd",
        "FeedConsumptionPerLayerPerDayCumulative": "Voer phpd cum",
        "FeedConversionRate": "VC",
        "FeedConversionRateCumulative": "VC cum",
        "FeedToEggRatio": "Voer/Ei",
        "MortalityCount": "Uitval",
        "MortalityRate": "Uitvalpercentage",
        "MortalityRateCumulative": "Uitval% cum",
        "RateOfLay": "Legpercentage",
        "TotalEggCount": "Totaal aantal eieren",
        "TotalEggCountSecondGrade": "Aantal eieren 2e soort",
        "TotalEggWeight": "Totaal eigewicht",
        "TotalEggWeightPerLayerInProductionCumulative": "Ei gewicht poh cum (kg)",
        "WaterConsumption": "Water",
        "WaterToFeedRatio": "Water/Voer",
        "SecondFeedConsumption": "Tweede voer"
      },
      "breeder-kpis": {
        "RateOfLay": "Legpercentage",
        "AverageEggWeight": "Gemiddeld eigewicht",
        "EggMassPerBreeder": "Eimassa per hen",
        "FeedPerBreeder": "Voer per hen",
        "FeedPerBreederPerDay": "Voer per hen per dag",
        "FeedToEggRatio": "Voer per ei",
        "FeedConversion": "Voerconversie",
        "WaterToFeedRatio": "Water-voer verhouding",
        "MortalityRate": "Uitvalpercentage",
        "ProductionFigure": "Productiegetal",
        "FeedPerHatchedEgg": "Voer per broedei",
        "HatchedEggsPerPlacedHen": "Aantal broedeieren POH",
        "EggsPerPlacedHen": "Eieren per opgehokte hen",
        "EggsPerPlacedHenCumulative": "Eieren per opgehokte hen cumulatief",
        "HenMortalityRate": "Uitvalpercentage hennen",
        "RoosterMortalityRate": "Uitvalpercentage hanen",
        "WaterInLiters": "Water",
        "HenWaterIntakeInLiters": "Water hennen",
        "RoosterWaterIntakeInLiters": "Water hanen",
        "HenCount": "Aantal hennen",
        "RoosterCount": "Aantal hanen",
        "RoosterPercentage": "Hanen %",
        "TotalFeedPerWeek": "Totaal voer (week)",
        "HenWeight": "Gewicht hennen",
        "RoosterWeight": "Gewicht hanen",
        "EggCount": "Aantal eieren",
        "EggWeightInGrams": "Gemiddeld eigewicht",
        "FertilityPercentage": "Vruchtbaarheid",
        "HatchPercentage": "Uitkomstpercentage",
        "HatchPercentageCumulative": "Uitkomstpercentage cumulatief",
        "HatchingEggCount": "Aantal broedeieren",
        "HenFeedIntakeInGrams": "Voeropname hennen",
        "HenMortality": "Sterfte hennen",
        "RoosterMortality": "Sterfte hanen",
        "LightHours": "Lichturen",
        "LightIntensity": "Lichtintensiteit",
        "RoosterFeedIntakeInGrams": "Voeropname hanen",
        "HatchedEggsCumulative": "Uitgekomen eieren cumulatief",
        "RateOfLayCumulative": "Legpercentage cumulatief",
        "AverageEggWeightCumulative": "Gemiddeld eigewicht cumulatief",
        "EggMassPerBreederCumulative": "Eimassa per hen cumulatief",
        "FeedPerBreederCumulative": "Voer per hen cumulatief",
        "FeedPerBreederPerDayCumulative": "Voer per hen per dag cumulatief",
        "FeedPerHatchedEggCumulative": "Voer per broedei cumulatief",
        "FeedToEggRatioCumulative": "Voer per ei cumulatief",
        "FeedConversionCumulative": "Voerconversie cumulatief",
        "WaterToFeedRatioCumulative": "Water-voer verhouding cumulatief",
        "MortalityRateCumulative": "Uitvalpercentage cumulatief",
        "HatchedEggsPerPlacedHenCumulative": "Aantal uitgekomen eieren POH cumulatief",
        "HenMortalityRateCumulative": "Uitvalpercentage hennen cumulatief",
        "RoosterMortalityRateCumulative": "Uitvalpercentage hanen cumulatief"
      },
      "view-filters": {
        "kpis": "KPI's",
        "manual-input": "Handmatige invoer",
        "moult": "Rui",
        "remarks": "Opmerkingen",
        "detailed": "Gedetaileerd"
      },
      "filters": {
        "title": "Grafiekopties",
        "description": "Hier vindt u de grafiek instellingen.",
        "labels": {
          "breed-category-name": "Ras categorie",
          "egg-marketing-standard": "Handelsnorm",
          "breed-name": "Ras",
          "data-sources": "Getoonde databronnen",
          "other-flock-placeholder": "Selecteer een koppel",
          "selector-option-barn": "Stal"
        },
        "breed-categories": {
          "overall": "Gemiddelde",
          "white": "Wit",
          "brown": "Bruin"
        },
        "egg-marketing-standards": {
          "0": "Biologisch",
          "1": "Vrije uitloop",
          "2": "Scharrel",
          "3": "Kolonie"
        },
        "breeds": {
          "Overall": "Gemiddelde"
        },
        "chart-lines": {
          "current-flock": "Geselecteerde koppel",
          "breeders-reference-benchmark": "Fokkersnorm",
          "porphyrio-benchmark": "Porphyrio benchmark",
          "other-flock": "Ander koppel",
          "other-flock-lower-case": "ander koppel"
        }
      },
      "benchmark": {
        "title": "Wekelijks overzicht van",
        "description": "Hier vindt u een wekelijks overzicht van de KPI:",
        "breedersReference": "Fokkersnorm",
        "cumulative": "Cumulatief",
        "porphyrioBenchmark": "Porphyrio benchmark",
        "flocks": "koppels",
        "error": {
          "no-data-sources-title": "Geen databronnen beschikbaar",
          "no-data-sources-description": "Er kan geen wekelijks overzicht worden getoond, omdat er geen databronnen zijn geselecteerd.",
          "no-data-title": "Geen data beschikbaar",
          "no-data-description": "Voor de huidige filtering is er voor één of meer geselecteerde databron(nen) geen data beschikbaar."
        },
        "axis": {
          "week": "Week",
          "values": "Waarden"
        }
      },
      "weekregistration-download": "Sjabloon downloaden",
      "weekregistration-upload": "Importeer",
      "weekregistration-select-file": "Selecteer een bestand...",
      "weekregistration-upload-csv-title": "Selecteer een CSV-bestand om te importeren",
      "upload-csv-message": "Kolommen mogen niet uit de template worden verwijderd, ook niet als ze leeg zijn. Velden kunnen wel leeg worden gelaten.",
      "upload-csv-notification": "Selecteer een CSV-bestand om te importeren",
      "weekregistration-select-interval-type": "Intervaltype",
      "interval-type-Day": "Dag",
      "interval-type-Week": "Week",
      "validation-errors": {
        "total-must-be-100": "Het totaal moet 100 zijn",
        "date-is-not-valid-title": "De datum klopt niet",
        "date-is-not-valid-description": "De datum klopt niet"
      },
      "date": "Datum",
      "days": "Dagen",
      "weeks": "Weken",
      "jump-to-week": "Ga naar week"
    },
    "no-flocks": {
      "title": "Er zijn nog geen koppels",
      "description": "Voeg een koppel toe en deze zal hier worden getoond."
    },
    "unassigned": "Niet toegewezen",
    "new-breeder-flock": "Nieuw koppel"
  },
  "week-registration": {
    "mortality": "Uitval",
    "eggsAmount": "Totaal aantal eieren",
    "eggsAmountSecondKind": "Aantal eieren 2e soort",
    "eggWeight": "Eigewicht",
    "forage": "Voer",
    "water": "Water",
    "henWeight": "Hengewicht",
    "moult": "Rui",
    "isInMoult": "Rui?",
    "isInMoultMessage": "Zijn de kippen in de rui deze week?",
    "moult-true": "Ja",
    "moult-false": "Nee",
    "remarks": "Opmerkingen",
    "amountOfHensStartOfWeek": "Aantal hennen start week",
    "amountOfRoostersStartOfWeek": "Aantal hanen start week",
    "amountOfHensStartOfFlock": "Aantal hennen start koppel",
    "amountOfRoostersStartOfFlock": "Aantal hanen start koppel",
    "henMortality": "Sterfte hennen",
    "roosterMortality": "Sterfte hanen",
    "roosterWeight": "Gewicht hanen",
    "henFeedIntakeInGrams": "Voer hennen",
    "roosterFeedIntakeInGrams": "Voer hanen",
    "henWaterIntakeInLiters": "Water hennen",
    "roosterWaterIntakeInLiters": "Water hanen",
    "eggCount": "Aantal eieren",
    "hatchingEggCount": "Aantal broedeieren",
    "eggWeightInGrams": "Eigewicht",
    "fertilityPercentage": "Bevruchtingspercentage",
    "hatchPercentage": "Uitkomstpercentage",
    "lightHours": "Uren licht",
    "lightIntensity": "Lichtintensiteit",
    "breed": "Ras",
    "barn": "Stal",
    "dateOfBirth": "Geboortedatum",
    "arrivalDate": "Opzetdatum",
    "week": "Week",
    "week-start": "Week start",
    "registration": "invoeren",
    "period": "Periode",
    "out-of-range": "Deze waarde valt buiten het bereik:",
    "whole-number-required": "Voer een heel getal in (zonder decimalen).",
    "hatching-egg-count-exceeds-egg-count": "Het aantal broedeieren mag niet hoger zijn dan het aantal eieren",
    "hatch-greater-than-fertility": "Het uitkomstpercentage moet lager zijn dan het bevruchtingspercentage",
    "too-much-mortality": "De som de uitval over alle dagen in deze week is hoger dan het aantal hennen aan het begin van de week!",
    "forageProduct": "Voerproduct",
    "secondForageToggle": "Tweede voerproduct toevoegen",
    "secondForage": "Tweede voer",
    "secondForageProduct": "Tweede voerproduct",
    "weekly-registrations": "Wekelijkse Observatie Registraties",
    "daily-registrations": "Dagelijkse Observatie Registraties"
  },
  "arrival-detail": {
    "title-edit": "Wijzigen Opzet",
    "title-create": "Aanmaken Opzet",
    "flock-name": "Koppel naam",
    "barn": "Stal",
    "chick-birthdate": "Geboortedatum",
    "arrival-date": "Opzetdatum",
    "production-period-start-date": "Startdatum productieperiode",
    "breed": "Ras",
    "amount-of-hens": "Aantal hennen",
    "egg-marketing-standard": "Handelsnorm",
    "hatchery": "Broederij",
    "input-mode": "Invoermethode",
    "input-mode-per-day": "Dagelijks",
    "input-mode-per-week": "Wekelijks",
    "input-mode-advanced": "Geavanceerd",
    "advanced-link": "Geavanceerd invoeren >",
    "back-to-general-data": "< terug",
    "advanced-settings-title": "Geavanceerde invoerinstellingen",
    "days": "dagen",
    "age-start-production-period": "Leeftijd start productieperiode",
    "housing-system": "Huisvestingssysteem",
    "bedding-type": "Strooisel",
    "bedding-amount": "Hoeveelheid strooisel",
    "transport-distance": "Transport vanaf opfokker",
    "transport-distance-error": "Het transport vanaf opfokker moet een getal zijn tussen 0 en 1000",
    "bedding-amount-error": "Hoeveelheid strooisel moet een positief getal zijn",
    "time-in-free-range": "Tijd in vrije uitloop",
    "time-in-free-range-error": "Tijd in vrije uitloop moet een getal zijn tussen 0 en 100",
    "hen-weight": "Hengewicht",
    "hen-weight-error": "Hengewicht moet een positief getal zijn",
    "hen-weight-comparison-error": "Gewicht moet lager zijn dan bij vertrek",
    "minimum-amount-of-hens-error": "Aantal kippen moet een positief getal zijn",
    "rearing-organization": "Opfokorganisatie",
    "amount-of-roosters": "Aantal hanen",
    "minimum-amount-of-roosters-error": "Aantal hanen moet een positief getal zijn",
    "show-rooster-fields": "Hanen registreren",
    "rooster-weight": "Hanengewicht",
    "rooster-weight-error": "Hanengewicht moet een positief getal zijn",
    "feed-system-hens": "Voersysteem hennen",
    "feed-system-roosters": "Voersysteem hanen",
    "drink-system": "Drinksysteem",
    "nest": "Nest"
  },
  "departure-detail": {
    "amount": "Aantal",
    "departureDate": "Afvoerdatum",
    "henWeightInGrams": "Hengewicht",
    "eggs-price": "Eierprijs",
    "eggs-price-error": "Eierprijs moet een positief getal zijn",
    "pieces": "stuks",
    "hens-price": "Prijs afgevoerde hennen",
    "hens-price-error": "Prijs afgevoerde hennen moet een positief getal zijn",
    "eggs-price-second-kind": "Prijs tweedekeuze eieren",
    "eggs-price-second-kind-error": "Prijs tweedekeuze eieren moet een positief getal zijn",
    "hen-weight-error": "Hengewicht moet een positief getal zijn",
    "hen-weight-comparison-error": "Het gewicht bij vertrek moet groter zijn dan bij aankomst",
    "minimum-amount-of-hens-error": "Aantal kippen moet een positief getal zijn",
    "amount-of-hens-comparison-error": "Aantal kippen mag niet groter zijn dan bij aankomst",
    "departure-date-comparison-error": "Afvoerdatum moet op of na de eerste toegestane datum liggen"
  },
  "report": {
    "title_all": "Koppel Rapport",
    "title_summary": "Koppel Samenvatting Rapport",
    "title_animalcount": "Diertelkaart",
    "animalcount": {
      "year": "Diertelkaart jaar:",
      "year-placeholder": "- selecteer een jaar -",
      "farmcompany": "Bedrijf",
      "customernr": "Klantnummer",
      "contactperson": "Contactpersoon",
      "location": "Locatie",
      "flock": "Koppel",
      "barn": "Stal",
      "arrivaldate": "Opzetdatum",
      "arrivalamount": "Aantal Opzet",
      "departuredate": "Afvoerdatum",
      "departureamount": "Aantal Afvoer",
      "mutationdate": "Datum mutatie",
      "reason": "Reden",
      "mutation": "Mutatie",
      "amountbeforemutation": "Aantal dieren voor mutatie",
      "amountaftermutation": "Aantal dieren na mutatie",
      "numberofdays": "Aantal dagen",
      "animaldays": "Dierdagen",
      "average": "Gemiddeld aanwezig",
      "total": "Totaal",
      "reasons": {
        "EndOfLastYear": "Einde vorig jaar",
        "Departure": "Afvoer",
        "Mortality": "Uitval",
        "EndOfYear": "Einde jaar",
        "Today": "Vandaag",
        "Arrival": "Aanvoer"
      }
    },
    "customer-details": {
      "header": "Klantgegevens",
      "customer-number": "Klantnummer",
      "name": "Naam",
      "address": "Adres",
      "city": "Postcode en plaats",
      "phone": "Telefoon",
      "location-name": "Locatie naam",
      "location-address": "Locatie adres",
      "location-city": "Locatie postcode en plaats",
      "location-phone": "Locatie telefoon"
    },
    "flock-details": {
      "header": "Koppel gegevens",
      "flock": "Koppel",
      "breed": "Ras",
      "amount-of-hens": "Aantal",
      "marketing-standard": "Handelsnorm",
      "arrival-date": "Opzetdatum",
      "departure-date": "Afleverdatum",
      "age-start-production-period": "Leeftijd start productie",
      "days": "dagen",
      "barn": "Verblijf"
    },
    "week-details": {
      "header": "Weekregistraties",
      "week": "Week",
      "cumulative": "Cumulatief",
      "weekStart": "Week start",
      "AverageEggWeight": "Eigewicht gem. (g)",
      "AverageEggWeightPerLayerPerDay": "Eimassa (g)",
      "AverageLayerWeight": "Hengewicht (g)",
      "EggCountPerLayerInProduction": "Ei poh",
      "EggCountPerLayerInProductionCumulative": "Ei poh cum",
      "FeedConsumption": "Voer (kg)",
      "FeedConsumptionPerLayerInProduction": "Voer poh (kg)",
      "FeedConsumptionPerLayerInProductionCumulative": "Voer poh cum (kg)",
      "FeedConsumptionPerLayerPerDay": "Voer phpd (g)",
      "FeedConsumptionPerLayerPerDayCumulative": "Voer phpd cum (g)",
      "FeedConversionRate": "VC",
      "FeedConversionRateCumulative": "VC cum",
      "FeedToEggRatio": "Voer/ei (g)",
      "MortalityCount": "Uitval",
      "MortalityRate": "Uitval (%)",
      "MortalityRateCumulative": "Uitval cum (%)",
      "RateOfLay": "Leg (%)",
      "TotalEggCount": "Totaal aantal eieren",
      "TotalEggCountSecondGrade": "Aantal eieren 2e soort",
      "TotalEggWeight": "Totaal eigewicht (kg)",
      "TotalEggWeightPerLayerInProductionCumulative": "Ei poh cum (kg)",
      "WaterConsumption": "Water (L)",
      "WaterToFeedRatio": "Water/voer",
      "SecondFeedConsumption": "2e Voer (kg)"
    }
  },
  "validation-error": {
    "required": "Verplicht veld",
    "title": "Validatie fout",
    "description": "Alle gegevens moeten worden ingevoerd."
  },
  "delivery-title": "Leveringen",
  "delivery": {
    "search-placeholder": "Zoek in leverbonnen",
    "overview-title": "Leveringen Overzicht",
    "empty-title": "Geen leveringen gevonden",
    "empty-description": "Er werden voor deze locatie geen leveringen gevonden.",
    "overview-table": {
      "deliveryDate": "Datum",
      "deliveryNote": "Leverbon",
      "orderNr": "Order nr",
      "productNr": "Product ID",
      "productName": "Product naam",
      "amount": "Aantal",
      "units": "Eenheden",
      "isActive": "Actief",
      "flock": "Koppel",
      "edit-title": "Bewerk Koppel Levering"
    }
  },
  "product-title": "Producten",
  "product-save": "Producten opslaan",
  "product-saved": "Product opgeslagen!",
  "product-overview": {
    "title": "Producten overzicht",
    "overview": {
      "productName": "Naam",
      "productCode": "Product code",
      "isActive": "Actief",
      "productType-Feed": "Voer",
      "productType-Additive": "Toevoeging",
      "type": "Producttype"
    },
    "no-products": {
      "title": "Geen producten gevonden",
      "description": "Klik op Toevoegen om een product aan te maken."
    },
    "delete-confirmation-title": "Product verwijderen",
    "delete-confirmation-message": "Weet je zeker dat je dit product wilt verwijderen?",
    "country": "Land"
  },
  "create-product": {
    "title-create": "Product toevoegen",
    "title-edit": "Product aanpassen:",
    "product-name": "Productnaam",
    "product-code": "Productcode",
    "error-product-name": "Vul de naam in van het product.",
    "error-product-code": "Vul de productcode in van het product.",
    "error-code-name-already-in-use": "Gebruik een unieke combinatie van naam en code",
    "product-type": {
      "label": "Producttype",
      "Feed": "Voer",
      "Additive": "Toevoeging"
    },
    "error-product-type": "Producttype is verplicht."
  },
  "countries": {
    "BE": "België",
    "DE": "Duitsland",
    "FR": "Frankrijk",
    "NL": "Nederland",
    "JO": "Jordanië",
    "NG": "Nigeria",
    "TZ": "Tanzania",
    "KE": "Kenia",
    "UG": "Oeganda"
  },
  "confirm-delete-flock-week-registration": "Weet u zeker dat u de weekregistratie wilt verwijderen?",
  "flock-week-registration-deleted": "De weekregistratie is verwijderd.",
  "feed-advice": {
    "overview": {
      "title": "Voeradvies overzicht",
      "empty": {
        "title": "Voeradvies data niet beschikbaar",
        "description": "Er is geen voeradvies data beschikbaar op dit moment."
      },
      "table-header": {
        "name": "Naam",
        "created": "Aangemaakt",
        "updated": "Aangepast",
        "updatedAdvisorName": "Aangepast door",
        "isActive": "Actief"
      },
      "buttons": {
        "add": "Voeradvies toevoegen",
        "edit": "Aanpassen",
        "delete": "Verwijderen"
      }
    },
    "create-from-reference": {
      "title": "Voeradvies aanmaken",
      "scratch-title": "Start een nieuw voeradvies",
      "scratch-option-title": "Start een voeradvies",
      "scratch-button": "Start met een leeg advies",
      "scratch-option-subtitle": "Dit is een leeg advies",
      "reference-schemes-title": "Kies een standaard voeradvies als basis",
      "reference-schemes-button": "Start met ",
      "product": "Product",
      "products": "Producten",
      "additive": "Toevoeging",
      "additives": "Toevoegingen"
    },
    "dialog": {
      "deleteConfirm": "Weet u het zeker of u dit voeradvies wilt verwijderen?",
      "deleteConfirmWhenInUse": "Dit voeradvies is gekoppeld aan een ronde, weet u het zeker of u dit voeradvies wilt verwijderen?"
    },
    "create": {
      "print": "Afdrukken",
      "title": "Voeradvies",
      "name": "Voeradvies naam",
      "error-name": "Voeradvies naam is verplicht",
      "description": "Omschrijving",
      "description-placeholder": "Voeradvies omschrijving",
      "product-placeholder": "- selecteer product -",
      "add-product": "Product toevoegen",
      "table-header": {
        "productName": "Product",
        "ageFrom": "Leeftijd van (wkn)",
        "ageTo": "Leeftijd tot (wkn)",
        "comment": "Opmerking",
        "age": "Leeftijd (wkn)",
        "dosage": "Adviesdosering (kg/ton)",
        "applicationMoment": "Leeftijd toepassing"
      },
      "created": "Aangemaakt",
      "updated": "Bijgewerkt",
      "validation-error": {
        "title": "Validatie fout(en)",
        "feedadvice-name": "Voeradvies naam is verplicht",
        "age-from": "Leeftijd van is verplicht",
        "product": "Product is verplicht",
        "age-to": "Leeftijd tot is verplicht (behalve in de laatste regel)",
        "age-min-max": "Leeftijd Van moet lager zijn dan Leeftijd Tot."
      },
      "products": "Basisadvies",
      "additives": "Toevoegingen",
      "show-additives": "Toon toevoegingen",
      "add-additive": "Toevoeging toevoegen"
    },
    "print": {
      "farmcompany": "Bedrijf",
      "customernr": "Klantnummer",
      "contactperson": "Contactpersoon",
      "location": "Locatie",
      "customerservice": "Klantenservice",
      "table-header": {
        "productName": "Product",
        "comment": "Opmerking",
        "dosage": "Dosering",
        "units_kgton": "kg/ton",
        "applicationMoment": "Leeftijd toepassing",
        "units_weeks": "(wkn)",
        "age": "Leeftijd"
      }
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Standaard voeradviezen overzicht",
      "empty": {
        "title": "Standaard voeradvies data niet beschikbaar",
        "description": "Er is geen standaard voeradvies data beschikbaar op dit moment."
      },
      "table-header": {
        "name": "Naam",
        "created": "Aangemaakt",
        "updated": "Aangepast",
        "updatedAdvisorName": "Aangepast door",
        "isActive": "Actief"
      },
      "buttons": {
        "add": "Standaard voeradvies toevoegen",
        "edit": "Aanpassen",
        "delete": "Verwijderen"
      },
      "country": "Land"
    },
    "dialog": {
      "deleteConfirm": "Weet u zeker dat u dit standaard voeradvies wilt verwijderen?"
    },
    "create": {
      "title": "Standaard voeradvies",
      "name": "Standaard voeradvies naam",
      "error-name": "Standaard voeradvies naam is verplicht",
      "description": "Omschrijving",
      "description-placeholder": "Standaard voeradvies omschrijving",
      "product-placeholder": "- selecteer product -",
      "add-product": "Product toevoegen",
      "table-header": {
        "productName": "Product",
        "ageFrom": "Leeftijd van (wkn)",
        "ageTo": "Leeftijd tot (wkn)",
        "comment": "Opmerking"
      },
      "created": "Aangemaakt",
      "updated": "Bijgewerkt"
    }
  },
  "housing-systems": {
    "aviary": "Volière",
    "cages": "Kooi",
    "colony": "Kolonie",
    "floor": "Traditionele scharrel",
    "free-range": "Vrije uitloop",
    "furnished-cages": "Verrijkte kooi",
    "organic": "Biologisch"
  },
  "sustainability": {
    "sustainability": "Duurzaamheid",
    "add-farm-resources": "Voeg energiebronnen toe",
    "farm-resources": "Energieverbruik per jaar",
    "carbon-footprint": "CO2 Voetafdruk",
    "confirm-delete-farm-resource": "De boerderijbron verwijderen?",
    "farm-resource-deleted": "Boerderijbron verwijderd",
    "farm-resource-saved": "Boerderijbron opgeslagen",
    "year": "Jaar",
    "resource": {
      "electricity": "Elektriciteit (kWh)",
      "electricity-photovoltaic": "Elektriciteit Zon (kWh)",
      "electricity-wind": "Elektriciteit Wind (kWh)",
      "natural-gas": "Aardgas (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Benzine (L)",
      "coal": "Steenkool (KG)",
      "propane-lpg": "Propaan / LPG (L)",
      "water": "Water (m³)",
      "flock-start-date": "Startdatum",
      "flock-end-date": "Einddatum",
      "status": "Status",
      "statuses": {
        "complete": "Afgesloten",
        "partial": "Onvolledig",
        "active": "Actief"
      },
      "water-error": "Water moet een positief getal zijn",
      "electricity-error": "Elektriciteit moet een positief getal zijn",
      "electricity-photovoltaic-error": "Elektriciteit Zon moet een positief getal zijn",
      "electricity-wind-error": "Elektriciteit Wind moet een positief getal zijn",
      "natural-gas-error": "Aardgas moet een positief getal zijn",
      "diesel-error": "Diesel moet een positief getal zijn",
      "gasoline-error": "Benzine moet een positief getal zijn",
      "propane-lpg-error": "Propaan/LPG moet een positief getal zijn",
      "coal-error": "Steenkool moet een positief getal zijn"
    },
    "farm-settings-saved": "Boerderij-instellingen opgeslagen",
    "farm-settings-enable-co2-calculation": "CO2-berekeningen inschakelen voor deze boerderij",
    "flock-resources": "Energieverbruik per koppel",
    "consumptionEgg": "Waarde eieren (kg CO2eq / kg eieren)",
    "spentHens": "Waarde afgevoerde hennen (kg CO2eq / kg hengewicht)",
    "notification-title": "Belangrijke informatie over CO2 berekeningen",
    "notification-description": "De berekening van de carbon footprint wordt uitgevoerd door de LCA software Sustell. Aan de basis ligt de CO2 op voer zoals uitgevoerd conform de actuele Nevedi instructie. Om een correctie berekening te kunnen uitvoeren moeten alle gegevens volledig zijn ingevoerd: <b>technische prestaties van volledig koppel incl. productie en afvoer/slacht en energieverbruik.</b>\nWeergegeven waarden kunnen onderhevig zijn aan veranderingen door aanpassing van de klimaatwetenschap en de daaruit volgende wijzigingen in de berekenings-systematiek, evenals wijzigingen in wet- en regelgeving en eventueel van toepassing zijnde standaarden. Hoewel de hier getoonde informatie zorgvuldig is samengesteld kunnen hieraan geen rechten ontleend worden.",
    "action-text-close": "Verbergen",
    "action-text-open": "Toon",
    "farm-resources-not-complete": "Energieverbruik per koppel is onvolledig.",
    "bedding-type-required": "Opzet - Strooiseltype is verplicht voor de koppel.",
    "bedding-amount-required": "Opzet - Hoeveelheid strooisel is verplicht voor de koppel.",
    "hen-weight-required": "Opzet - Hengewicht is verplicht voor de koppel.",
    "start-calculation": "Start met het berekenen van CO2",
    "refresh-carbon-footprint": "Ververs CO2 voetafdruk",
    "carbon-footprint-title-error": "Fout bij berekening van CO2 voetafdruk",
    "carbon-footprint-title": "Berekening van de CO2 voetafdruk",
    "carbon-footprint-text": "De berekening van de CO2 voetafdruk zal starten. Even geduld alstublieft terwijl het proces wordt voltooid (ongeveer 1 minuut).",
    "carbon-footprint-refresh-error-title": "Fout bij het verversen van de CO2 voetafdruk",
    "week-registrations-required": "Weekregistratiegegevens zijn vereist voor CO2-voetafdrukberekening.",
    "day-registrations-missing": "Dagelijkse registratiegegevens ontbreken voor sommige weekperioden.",
    "week-registrations-incomplete": "Weekregistraties moeten geldige gegevens bevatten voor de hele koppelperiode.",
    "carbon-footprint-500-error-message": "Er is een fout opgetreden bij het berekenen van de CO2-voetafdruk. Dit kan komen doordat uw weekregistratiegegevens onvolledig of ontbrekend zijn. Zorg ervoor dat u productiegegevens (eieren, voerverbruik, mortaliteit, enz.) hebt ingevuld voor uw koppelperiode voordat u het opnieuw probeert."
  },
  "bedding-types": {
    "NoBedding": "Geen strooisel",
    "BarleyStraw": "Gerst stro",
    "MaizeStover": "Maïsloof",
    "OatStraw": "Haver stro",
    "SawDust": "Zaagsel",
    "SunflowerHusk": "Zonnebloemschillen",
    "WheatStraw": "Tarwestro",
    "Woodshavings": "Houtkrullen"
  },
  "feed-systems": {
    "Ketting": "Ketting",
    "Pannen": "Pannen",
    "Spiraal": "Spiraal"
  },
  "drink-systems": {
    "Cups": "Cups",
    "Nippels": "Nippels",
    "RondDrinkers": "Ronddrinkers"
  },
  "nests": {
    "WegrolNest": "Wegrolnest",
    "Handgeraapt": "Handgeraapt"
  },
  "title_Agravis": "Avidata Legehenne"
}
